var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectionOk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_285_1584)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0C18.45 0 18 0.45 18 1V9.01C18.69 9.05 19.36 9.18 20 9.37V1C20 0.45 19.55 0 19 0ZM13 4.99999C13.55 4.99999 14 5.44999 14 5.99999V9.75999C13.27 10.08 12.6 10.51 12 11.02V5.99999C12 5.44999 12.45 4.99999 13 4.99999ZM6 12V23C6 23.552 6.448 24 7 24C7.552 24 8 23.552 8 23V12C8 11.448 7.552 11 7 11C6.448 11 6 11.448 6 12ZM1 24C1.552 24 2 23.552 2 23V16C2 15.448 1.552 15 1 15C0.448 15 0 15.448 0 16V23C0 23.552 0.448 24 1 24ZM17.5 24C21.084 24 24 21.084 24 17.5C24 13.916 21.084 11 17.5 11C13.916 11 11 13.916 11 17.5C11 21.084 13.916 24 17.5 24ZM20.5368 16.3354L17.7868 19.8354C17.4368 20.2823 16.7808 20.3474 16.3498 19.9774L14.5998 18.4774C14.1798 18.1183 14.1308 17.4864 14.4918 17.0674C14.8508 16.6483 15.4828 16.6004 15.9008 16.9594L16.8588 17.7803L18.9638 15.1013C19.3048 14.6674 19.9328 14.5903 20.3678 14.9333C20.8028 15.2724 20.8788 15.9014 20.5368 16.3354Z",
    fill: "#01974C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_285_1584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionOk);
export default __webpack_public_path__ + "static/media/connection-ok.2286de013434864ccc4c46fa83149055.svg";
export { ForwardRef as ReactComponent };